import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import sanitizeHtml from 'sanitize-html'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CollectionImage from './CollectionImage'

const data = {
  heading: `Collection`,
  section1: `Customer data lives everywhere: your website, your mobile apps, and internal tools.`,
  section2: `That’s why collecting and processing all of it is a tricky problem. Segment has built libraries, automatic sources, and functions to collect data from anywhere—hundreds of thousands of times per second.`,
  section3: `We’ve carefully designed each of these areas to ensure they’re:`,
  section4: `<ul><li>Performant (batching, async, real-time, off-page)</li>
  <li>Reliable (cross-platform, handle rate-limits, retries)</li>
  <li>Easy (setup with a few clicks, elegant, modern API)</li></ul>`,
  section5: `Here’s how we do it.`,
}

const Collection: FC<PropsWithChildren<unknown>> = () => {
  const { heading, section1, section2, section3, section4, section5 } = data
  return (
    <Wrapper>
      <SectionBase variant="2Col" copyVariant="wide">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading tag="h2">{heading}</CopyText.Heading>
            <CopyText.Description tag="div">
              <CopyTextDescriptionSection>{section1}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>{section2}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection>{section3}</CopyTextDescriptionSection>
              <CopyTextDescriptionSection
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(section4, { allowedTags: [`ul`, `li`, `br`] }),
                }}
              />
              <CopyTextDescriptionSection>{section5}</CopyTextDescriptionSection>
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <CollectionImage />
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const CopyTextDescriptionSection = styled.div`
  margin-bottom: 32px;
`

const Wrapper = styled.section`
  display: grid;
`

export default Collection
